(function () {
  if (window.__purchaseProtectionInit) return;
  window.__purchaseProtectionInit = true;

  function getConfig() {
    return window.PurchaseProtectionConfig || null;
  }

  function getConsentInput() {
    return document.getElementById('checkbox-cart-policy-consent-mini-cart');
  }

  function consentOk() {
    var c = getConsentInput();
    return !c || !!c.checked;
  }

  function setLoading(isLoading, scopeEl) {
    (scopeEl || document).querySelectorAll('[data-pp-action]').forEach(function (el) {
      el.disabled = !!isLoading;
      el.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    });
  }

  function tierVariantForSubtotalCents(subtotalCents, variants) {
    var c = Number(subtotalCents || 0);
    if (c < 5000) return Number(variants.t1);
    if (c < 10000) return Number(variants.t2);
    if (c < 20000) return Number(variants.t3);
    return Number(variants.t4);
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to load cart');
    return await res.json();
  }

  function subtotalExcludingProtection(cart, protectionProductId) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      if (Number(item.product_id) === Number(protectionProductId)) return;
      sum += Number(item.final_line_price || 0);
    });
    return sum;
  }

  async function removeAllProtectionLines(cart, protectionProductId) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (Number(item.product_id) === Number(protectionProductId)) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    var res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });

    if (!res.ok) throw new Error('Failed to remove protection');
  }

  async function addVariantQty1(variantId) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!res.ok) throw new Error('Failed to add protection');
  }

  function goCheckout() {
    window.location.href = '/checkout';
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-pp-action]');
    if (!btn) return;

    var footer = btn.closest('.mini-cart-footer, .drawer__footer, .cart-drawer__footer, .header-cart-footer');
    if (!footer) footer = document;

    if (!consentOk()) {
      var c = getConsentInput();
      if (c) c.reportValidity();
      return;
    }

    var config = getConfig();
    if (!config) {
      console.error('[PP] Missing PurchaseProtectionConfig');
      return;
    }

    var action = btn.getAttribute('data-pp-action');

    try {
      setLoading(true, footer);

      var cart = await fetchCart();

      if (action === 'with') {
        await removeAllProtectionLines(cart, config.productId);

        var cart2 = await fetchCart();
        var subtotal = subtotalExcludingProtection(cart2, config.productId);
        var tierVariantId = tierVariantForSubtotalCents(subtotal, config.variants);

        await addVariantQty1(tierVariantId);
        goCheckout();
        return;
      }

      if (action === 'without') {
        await removeAllProtectionLines(cart, config.productId);
        goCheckout();
        return;
      }
    } catch (err) {
      console.error('[PP] error:', err);
      goCheckout();
    } finally {
      setLoading(false, footer);
    }
  });
})();